import { Accordion, AccordionSummary, AccordionDetails, Box, Typography, Link, List, ListSubheader, ListItem, Table, TableContainer, Paper, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const ElectioneeringCommunication = (): JSX.Element => {
    const reports = [
        {
            report: '7-day Report',
            description: 'Every individual, group, corporation or association that makes an electioneering communication expenditure must file an electronic report with OCPF within seven days after making the expenditure ($250 threshold).',
        },
        {
            report: '48-hour Report',
            description: 'A report is due within 48 hours for any electioneering communication exceeding $1,000 that is made within seven days of an election.',
        },
    ];

    return (

        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Electioneering Communication
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                An electioneering communication is any broadcast, cable, mail, satellite or printed communication that refers to a clearly identified candidate without advocating for a vote or against the candidate, and is distributed within 90 days of an election.
                Certain communications are excluded from the deginition of "electioneering communications". For more information, please review MGL c.55 § 1 and 18F, and <Link href='https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-06-01.pdf' target='_blank'>IB-06-01</Link>.
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom marginTop={2}>
                To disclose electioneering communications click <Link underline="none" href="https://www.ocpfreporter.us/Account/Register" target="_blank">here</Link> to register and file Independent Spending Reports with OCPF.
                Reports are filed with the city or town clerk for communications that identify municipal candidates who do not file with OCPF.
            </Typography>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" marginBottom={1}><b>Filing Schedules</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Report</b></TableCell>
                                    <TableCell><b>Description</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reports.map((report, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Typography variant='body2' color="primary">
                                                {report.report}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>{report.description}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>


        </Box>
    )
};

export default ElectioneeringCommunication;